<template>
	<div>
		
		<v-dialog v-model="dialog" width="600" :fullscreen="!$mq.isDesktop()">
			<v-card class="pa-5 pb-10 text-center" v-if="order">

				<div
					class="flex pa-5"
				>
					<h3 class='ma-0' style='margin: 0'>
					  
					</h3>
					<span class="flex-grow-1" />
					<v-btn @click="closeDialog(true)" icon><i class="fas fa-close" style='font-size: 32px'/> </v-btn>
				</div>


				<i class="fas fa-exclamation-triangle fa-3x" style="color:var(--quomi-orange)"></i>
				<h3 class="text-center pt-5 text-bold">Modifica dell'ordine</h3>
				<p class="text-body-mid">Dopo le modifiche devi arrivare alla <b>pagina di conferma</b>, o il tuo ordine non verrà processato. Il tuo carrello attuale verrà svuotato.</p>

				<CTA
					class="ma-auto"
					:content="`Modifica l'ordine`"
					@click="modifyOrder()"
					:loading="loading.cta"
				/>
			</v-card>
		</v-dialog>

		<h3 class="orders-title" v-html="`Le mie spese`"/>

		<div v-if="orders && !orders.length">
			<p>Non ci sono ancora spese da te effettuate. Fai ora il tuo primo ordine e prova la qualità Quomi!</p>
			<router-link :to="{ name: 'flow-subscribed' }">
					<CTA
						:content="`Ordina ora`"
						isArrow
					/>
			</router-link>
		</div>

		<section-toggle
			v-if="orders && orderToShow(order)"
			v-for="(order, index) in orders"
			:key="index"
			:trigger.sync="orders.find(r => r.id === order.id).isOpened"
			:lastOrder.sync="order.is_pending"
			class="section-toggle"
		>
			<template
				slot="title"
			>
				<div
					class="delivery-date"
				><span class=" text-bold">{{ deliveryDate(order) }}</span><br>
        <span style="font-size: 12px">n. ordine {{ order.id }}</span>
				</div>
				<div class="flex-fill"></div>
				<div class="can-modify mr-10"
					v-if="order && order.is_pending && !order.is_skip"
				>
					<v-chip
						v-if="!$mq.isDesktop() && order.recurring"
						:small="!$mq.isDesktop()" 
						class="order-status-mobile py-2 my-1" 
					>
						In Abbonamento
					</v-chip>
					<span>Puoi modificare la tua spesa entro le 23:00 di {{ dateCutOff(order) }}</span>
				</div>
				<div class="can-modify mr-10" v-if="order && order.is_paid || order.is_unpaid">
					<span>Rivedi i prodotti di questa spesa e riordinali </span>
				</div>

				<v-chip
					class="order-status-desktop mr-5" 
					v-if="order.recurring"
				>
					In Abbonamento
				</v-chip>
				<div class="flex-fill"></div>
				<v-chip
					:small="!$mq.isDesktop()" 
					class="order-status mr-3" 
					:class="status(order).class"
					style="min-width: fit-content"
				>
					{{ status(order).label }}
					<i class="fa fa-check fa-xs pl-3" aria-hidden="true" v-if="order.is_paid"></i>
				</v-chip>
			</template>

			<template
				slot="content"
			>
				<div
					class="order-box"
				>
					<div
						class="flex order-top"
					>
						<div>
							<h3>Dettagli spesa del {{ detailDate(order) }}</h3>
							<div class="table">
								<div class="table-row">
									<div
										class="table-cell"
										v-html="`Numero ordine:`"
									/>	
									<div
										class="table-cell"
										v-html="order.id"
									/>
								</div>
								<div class="table-row" v-if="order.prices.plan > 0" >
									<div
										class="table-cell"
										v-html="`N° Ricette:`"
									/>
									<div
										class="table-cell"
										v-html="`${order.plan.meals} ricette`"
									/>
								</div>
								<div
									class="table-row"
									v-if="order.prices.plan > 0"
								>
									<div
										class="table-cell"		
										v-html="`Kit Ricette:`"
									/>
									<div class="table-cell">
										€ {{ order.prices.plan }}
									</div>
								</div>
								<div
									class="table-row"
									v-if="order.prices.recipes > 0"
								>
									<div
										class="table-cell"		
										v-html="`Premium:`"
									/>
									<div class="table-cell">
										€ {{ order.prices.recipes }}
									</div>
								</div>
								<div
									class="table-row"
									v-if="order.prices.extras > 0"
								>
									<div
										class="table-cell"		
										v-html="order.prices.plan > 0 ? `Altri prodotti:` : `Spesa`"
									/>
									<div class="table-cell">
										€ {{ order.prices.extras }}
									</div>
								</div>
								<div
									class="table-row"
									v-if="order.transactions && order.transactions.edenred !== null"
								>
									<div
										class="table-cell"		
										v-html="`Buoni pasto:`"
									/>
									<div class="table-cell">
										€ {{ order.transactions.edenred }}
									</div>
								</div>
								<div
									class="table-row"
								>
									<div
										class="table-cell"		
										v-html="`Consegna:`"
									/>
									<div class="table-cell">
										€ {{ order.prices.delivery  }}
									</div>
								</div>
								<div
									class="table-row"
									v-if="orderHasDiscount && order.prices.discount != 0"
								>
									<div
										class="table-cell"		
										v-html="`Sconto:`"
									/>
									<div class="table-cell">
										-€ {{ order.prices.discount  }}<span v-if="order.transactions.wallet > 0"> (di cui € {{order.transactions.wallet}} dal portafoglio)</span>
									</div>
								</div>
								<div
									class="table-row"
									v-if="order.is_refunded"
								>
									<div
										class="table-cell"		
										v-html="`Rimborso:`"
									/>
									<div class="table-cell">
										€ {{ order.prices.refunded  }}
									</div>
								</div>
								<div
									class="table-row"
								>
									<div
										class="table-cell"		
										v-html="`<b>TOTALE:</b>`"
									/>
									<div class="table-cell">
										<b>€ {{ order.prices.net  }}</b>
									</div>
								</div>
								<div class="table-row">
									<div 
										class="table-cell"
										v-html="`Giorno di consegna:`"
									/>
									<div 
										class="table-cell"
										v-html="`Prevista per ${$_dates_readableDate(order.date.delivery)}`">
									</div>
								</div>
								<div class="table-row">
									<div 
										class="table-cell"
										v-html="`Orario di consegna:`"
									/>
									<div 
										class="table-cell">
										<span v-if="order.delivery && order.delivery.timeRange">{{ readableHour(order.delivery.timeRange.attributes.start)  }} - {{ readableHour(order.delivery.timeRange.attributes.end) }} </span>
									</div>
								</div>
								<div class="table-row">
									<div 
										class="table-cell"
										v-html="`Tipo di consegna`">	
										</div>
										<div
											class="table-cell first-lower"
											v-if="delivery"
											v-html="isFP ? 'Consegna punto di ritiro' : 'Consegna a domicilio'"
										/>
									</div>
								<div
									class="table-row"
								>
									<div
										class="table-cell"
										v-html="`Tipo di spedizione:`"
									/>
									<div
										class="table-cell first-lower"
										v-html="`Corriere tradizionale`"
									/>
								</div>
								<div
									class="table-row"
									v-if="order.delivery"
								>
									<div
										class="table-cell"
										v-html="`Indirizzo:`"
									/>
									<div
										class="table-cell"		
									>
										<span>{{ order.delivery.attributes.name }} - </span>
										<span>{{ order.delivery.address.attributes.readable }} </span>
									</div>
								</div>
							</div>
					<!-- 		<div>
								<span
									v-html="`Ordine `"
								/>
								<span
									v-html="`#${ order.id }`"
								/>
							</div> -->
<!-- 							<div>
								<tracking-code
									v-if="index <= 3"
									:order="order"
								/>
								<br>
								<div
									v-if="showTypeOfShipment(order)"
									v-html="`Tipo di spedizione: corriere tradizionale`"
								/>
								<div
									v-html="`Giorno di consegna: ${ deliveryDate(order) }`"
								/>
								<div
									v-html="`Piano: ${ order.plan.meals } ricette per ${ order.plan.people } persone`"
								/>
							</div> -->
						</div>
					</div>

					<br>

					<div class="items-listing">
						<SliderQ
							:maxNumSlides="6"
							:minSizeOfSlide="150"
							:minNumSlides="2"
						>
							<slide
								v-for="(item, index) in order.recipes.concat(order.extras)"
								v-if="order.recipes"
							>
								<small-item-box
									:class="{'not-available': item.availability == 0 }"
									:itemTitle="item.title + quantityType(item) + quantity(item)" 
									:itemImage="item.images.small ? item.images.small : item.images.big"
									:itemUrl="item.url ? `/ricetta/${item.url}` : null"
								/>
							</slide>
						</SliderQ>
						<div class="tag-partner mt-5 flex justify-content-end" v-if="order && order.is_paid || order.is_unpaid">
							<CTA
								class="mr-10"
								:content="$t('components.checkout.bill.rebuy')"
								@click="setAlert(true)"
							/>
						</div>
						<!-- Start: Alert per riordina prodotti -->
						<v-dialog v-model="alert" width="600" :fullscreen="!$mq.isDesktop()">
							<v-card class="pa-5 pb-10 text-center">

								<div class="flex justify-content-end">
									<v-btn @click="setAlert(false)" icon><i class="fas fa-close" style='font-size: 32px'/> </v-btn>
								</div>

								<div class="flex flex-column flex-vcenter mt-5">
								<h2 class="mb-5">Attenzione</h2>
								<i class="fas fa-exclamation-triangle fa-3x" style="color:var(--quomi-orange)"></i>
								<p class="text-body-mid pt-5 px-5">Dopo aver cliccato su "riordina prodotti" vai alla cassa per confermare il tuo ordine. Il tuo carrello attuale verrà svuotato.</p>
									<CTA
										:loading="loadingRebuy"
										:content="$t('components.checkout.bill.rebuy')"
										@click="$_recreateOrder(order)"
									/>
									<span class="alert-close" @click="setAlert(false)">Annulla</span>
								</div>
							</v-card>
					</v-dialog>
					<!-- --End-- -->
					</div>
					<div v-if="order && order.is_pending && order.confirmed_at == null && !order.is_skip">
						<div class="button-group mt-5">
							<div class="label">
								Addebiteremo € {{ order.prices.net }} sul tuo conto {{ dateCheckout(order) }}.  Potrai sempre modificare il tuo ordine fino a {{ dateCutOff(order) }}.
							</div>
							<div class="orders-buttons" style="display:flex">
								<CTA
									v-if="!order.last_error"
									:content="`Modifica l'ordine`"
									@click="openDialog(order)"
								/>
								<CTA
									v-if="order.last_error"
									:content="`Conferma pagamento`"
									:loading="loadingPayment"
									@click="confirmPayment(order)"
								/>

								<order-delete class="mx-5" v-on:deleted="load()" :order="order" />
							</div>
						</div>
					</div>
				</div>
			</template>
		</section-toggle>
		
		<loading-spin
			:height="150"
			v-if='!orders'
		/>

		<pagination
			v-if="pagination"
			:currentPage="pagination.current_page"
			:lastPage="pagination.last_page"
			@selectPage='loadOrders'
		/>

	</div>
</template>

<script>
import SectionToggle from '../Parts/SectionToggle'
import TrackingCode from './TrackingCode'
import SmallItemBox from '../Parts/SmallItemBox'
import Pagination from '../Parts/Pagination'
import { UserApi } from '../../api/UserApi'
import { Order } from '../../core/Order'
import OrderDelete from '../Elements/OrderDelete'
import { dates } from '../../mixins/dates'
import { OrderApi } from '../../api/OrderApi'
import { orderStore } from '../../store/orderStore'
import { menuStore } from '../../store/menuStore'
import { recreateOrder } from '../../mixins/recreateOrder'
import { DeliveryApi } from '../../api/DeliveryApi'

const moment = require('moment')

export default {
	props: {
		user: {
			type: Object,
			default () {
				return null
			}
		},

		orderId: {
			type: Number,
			default: null
		}
	},

	data () {
		return {
			loadingPayment: false,
			orders: null,
			pagination: null,
			page: 1,
			show: 3,
			dialog: false,
			alert: false,
			order: null,
			loading: {
				cta: false,
				orders: false
			},
			loadingRebuy: false,
			menuStore: menuStore.state,
		}
	},

	components: {
		SectionToggle,
		TrackingCode,
		SmallItemBox,
		Pagination,
		OrderDelete,
	},

	mixins: [
		dates,
		recreateOrder
	],
	computed: {
		address () {
			return this.delivery
				&& this.deliveryStore
				&& this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id)
				&& this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id).attributes
		},

		delivery () {
			var sub = this.user.subscription
			return this.deliveryStore
				&& this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id)
				&& this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id).attributes
		},

		isFP () {
			return this.delivery
				&& this.delivery.code
				&& this.delivery.code.includes('FP')
		},

		checkConfirmedExist() {

			if (!this.orders) {
				return null;
			}

			return this.orders.some((order) => {
				return order.id != this.order.id && order.is_pending && order.date.confirmed_at != null
			})
		},

		currentOrder() {
			return this.user ? this.user.order : null;
		},

	},
	methods: {
		showCoupon (order) {
			if (!order || !order.discount || !order.discount.group) return
			if (order.discount.group.length <= 0) return
			if (!order.discount.group[0]) return
			if (!order.discount.group[0].coupon) return
			return order.discount.group[0].coupon.code
		},

		status (order) {
			if (!order) {
				return
			}
			if (order.last_error && !order.is_refunded) return  {label: 'Autorizzazione fallita', class: 'qbg-error' }

			if (!order.is_pending) {
				if (order.is_paid) return {label: 'Pagato', class: 'qbg-primary' }
				if (order.is_refunded) return  {label: 'Rimborsato', class: 'qbg-secondary' }
				if (order.is_unpaid) return  {label: 'Pagamento fallito', class: 'qbg-error' }
			}else if (order.is_pending) {
				if(order.date.confirmed_at !== null) return  {label: 'Confermato', class: 'qbg-primary' }
				if(order.date.confirmed_at == null) return  {label: 'In corso', class: 'qbg-warning' }
			}
			return ''
		},

		orderHasDiscount (order) {
			if (!order) return
			return +order.prices.discount > 0
		},

	    dateCheckout (order) {
	    	return this.$_dates_readableDate(order.date.checkout)
	    },
	    dateCutOff (order) {
	    	return this.$_dates_readableDate(order.date.cutoff)
	    },

		orderToShow (order) {
			return true;
			// return order && !order.is_need_confirm && order.is_valid_recipes
		},

		showTypeOfShipment (order) {
			return order && order.is_closed && !order.is_delivered
		},

		deliveryDate (order) {
			return moment(order.date.delivery).locale('it').format('ddd, D MMM YYYY')
		},

		detailDate(order) {
			return moment(order.date.delivery).locale('it').format('D MMMM YYYY')
		},

		readableHour(param) {
			return param.slice(0,5)
		},

		purchaseDetailsDate(order) {
			if(order.date.confirmed_at !== null) {
				return 'Dettagli spesa del ' + moment(order.date.confirmed_at).locale('it').format('D MMMM YYYY')
			}
			return 'Dettagli spesa'
		},

		toShop() {
			this.$router.push({ name: 'flow-subscribed'})
		},

		openDialog(order) {
			if (order.is_pending && order.date.confirmed_at == null) {
				this.toShop();
				return;
			}

			this.order = order
			this.setDialog(true)
		},

		closeDialog() {
			this.order = null
			this.setDialog(false)
		},

		confirmPayment(order){

			this.order = order

			if (this.loadingPayment) {
				return;
			}
			this.loadingPayment = true;

			return this.modifyOrder().then(i => {
				this.loadingPayment = false
				this.$router.push({ name: 'verify-page' })
			})
		},

		modifyOrder(){
			let promise = this.currentOrder ? orderStore.deleteCurrentOrder() : Promise.resolve(1)

	      	this.loading.cta = true;
			return promise.then(i => {
				var api = new OrderApi
				return api.update(this.order.token, {})
			}).then(i => { 
				// use new order
				this.order.date.confirmed_at = null
		        this.user.order = this.order;
		        orderStore.state.order = this.order;
		        this.$root.updateUser(this.user)
				this.toShop();
			})
		},

		setDialog(dialog) {
			this.dialog = dialog
		},

		setAlert(alert) {
			this.alert = alert
		},
		
		loadOrders (page) {
			this.orders = null;
			let orders = null
			var um = new UserApi()
			um.orders({
				page: page,
				show: this.show,
				sort: '-created_at',
				query: 'status != "canceled" and ((status = "pending" and recurring = 1) or status != "pending" or (status = "pending" and confirmed_at is not null and ok = 1))'
			}).then(response => {
				orders = response.body.resources.filter(order => {
					return new Order(order)
				})
				this.pagination = response.body.meta.pagination

				if (this.$route.params.orderId) this.orders.find(r => r.id === this.$route.params.orderId).isOpened = true
			}).then(() => {
				var api = new DeliveryApi()
				let id = orders.map(order => order.id)
				return api.getDelivery({params: {query: `target_type='order' and target_id in (${id.join(',')})`, include: 'address,timeRanges'}})
			}).then((response)=> {
				let deliveries = response.body.data.map(el => {
					el.relationships.address.data.id  /* id e type */		
					/* el.relationships.timeRanges.data[0].id /* id e type*/ 
					let address = response.body.included.find(res => {
						return res.id == el.relationships.address.data.id && res.type == "address"
					})
					let timeRange = el.relationships.timeRanges ? response.body.included.find(res => {
						return res.id == el.relationships.timeRanges.data[0].id && res.type == "time-range"
					}) : null
					el.address = address
					el.timeRange = timeRange
					return el
				})
				this.orders = orders.map(order => {
					let delivery = deliveries.find(delivery => {
						return delivery.attributes.target_id == order.id
					})
					order.delivery = delivery
					return order
				})
				})
			.catch(response => {
				this.orders = []
			})
		},

		quantity(item) {
			if(item.cg1) {
				return item.quantity
			}else {
				return item.quantity * 2
			}
		},

		quantityType(item) {
			if(item.cg1) {
				return ' Qt '
			} else {
				return ' Porz. '
			}
		},

		load () {
			this.loadOrders(this.page)
		},
	},

	mounted () {
		this.load()
		menuStore.loadCurrentMenu()
	}
}

</script>

<style scoped>
.rebuy-btn {
	width: fit-content;
	display: inline;
	border: 2px solid var(--quomi-primary);
	border-radius: 20px;
	color: var(--quomi-primary);
}

.alert-close:hover {
	cursor: pointer;
	text-decoration: underline;
}

.section-toggle >>> .title,
.line {
	background-color: #ededed;
	border-radius: 4px;
	padding: 50px 20px;
	margin-bottom: 15px;
	cursor: pointer;
}

.delivery-date {
	font-size: 18px;
}
.delivery-date::first-letter {
	text-transform: uppercase;
}

.fa-chevron-right.transformed {
	transform: rotate(90deg);
}

.fa-chevron-right {
	transition: transform 0.3s ease;
}

.order-box {
	margin-bottom: 30px;
	padding: 10px;
}


.order-status::first-letter {
	text-transform: uppercase;
}

.order-status.confermata {
	background-color: grey;
	padding: 15px 10px;
	font-size: 18px;		
}


.order-status.pagata
{
	background-color: var(--quomi-primary-hover);
	padding: 10px 10px;
}

.order-status.in.corso {
	background-color: var(--quomi-orange);
	padding: 15px 10px;

}

.order-status.pagamento.fallito,
.order-status.rimborsata {
	padding: 15px 10px;
}

.order-status.pagamento.fallito {
	background-color: var(--quomi-red-hover);
}

.order-status.rimborsata {
	background-color: var(--quomi-blue);
}

.order-price {
	font-size: 24px;
}

.items-listing {
	margin: 0 -10px;
}

.table {
	margin: 10px 0;
	text-align: left;
	width: auto;
}


.table-cell {
	padding: 10px 20px 10px 0;
}

.table-cell:first-child {
	color: #5a5959;
	font-weight: bold;
}

.not-available {
	opacity: 0.4;
}

.button-group {
	flex-wrap: wrap;
}

@media (max-width: 800px) {
	.order-box {
		padding: 10px;
	}

	.order-top {
		flex-direction: column;
	}

	.order-price-block {
		margin: 0;
	}
}

@media (max-width: 481px) {
	.delivery-date {
		font-size: 13px;
	}
	
	.order-status.pagamento.fallito span{
		font-size: 12px !important;
	}
	.can-modify {
		position: absolute;
		display: flex;
		flex-direction: column;
		align-items: center;
		top: 55%;
		bottom: 0;
		font-size: 12px;
	}

	.section-toggle >>> .title,
	.line {
	padding-bottom: 30%;
}
}

@media (min-width: 768px) {
	.order-status-mobile {
		display: none;
	}
}

@media (max-width: 481px) {
	.order-status-desktop {
		display: none;
	}

	.can-modify {
		align-items: flex-start;
	}
}

@media (max-width: 1024px) {
/* 	.can-modify {
		position: absolute;
		top: 73%;
		bottom: 0;
		height: 50%;
		font-size: 8px;
	} */
	.modal-card:first-child {
		padding-top: 30% !important;
	}
	.orders-title {
		display: none;
	}
	.button-group {
		display: flex;
		flex-flow: column-reverse;
	}

	.button-group > .label {
		text-align: center;
	}

	.orders-buttons {
		display: flex;
		flex-direction: column;
		margin-bottom: 10px;
	}
}
</style>
